// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Transaction_main_nav__xuDbH {
  display: flex;
  margin: 2rem 0;
  border-bottom: solid 1px var(--color-dark);
  gap: 2rem;
  width: fit-content;
}
.Transaction_main_nav_item__Q9ypL {
  cursor: pointer;
  padding: 1rem 0;
  font-size: var(--default-font-small);
}
.Transaction_main_nav_item_active__KDOp8 {
  cursor: pointer;
  padding: 1rem 0;
  font-weight: 700;
  border-bottom: solid 2px var(--color-dark);
}
.Transaction_main_nav_item__Q9ypL:hover, .Transaction_main_nav_item__Q9ypL:focus, .Transaction_main_nav_item__Q9ypL:focus-visible, .Transaction_main_nav_item__Q9ypL:focus-within {
  font-weight: 700;
}

.Transaction_upper__sy-C7 {
  display: grid;
  grid-template-columns: 72rem 1.5fr;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Transaction_upper__sy-C7 {
    grid-template-columns: 60rem 1fr;
  }
}
@media only screen and (max-width: 56.25em) {
  .Transaction_upper__sy-C7 {
    grid-template-columns: 100%;
  }
}
.Transaction_upper__metrics__0yD9n {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
  overflow: hidden;
}
@media only screen and (max-width: 62.5em) {
  .Transaction_upper__metrics__0yD9n {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media only screen and (max-width: 50em) {
  .Transaction_upper__metrics__0yD9n {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Transaction_upper__metrics__0yD9n {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Transaction_upper__metrics_totalIncome__73B5G {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Transaction_upper__metrics_outstandingIncome__i8yyY {
  background-color: var(--color-yellow);
}
.Transaction_upper__metrics_totalSales__VU09\\+ {
  background-color: var(--color-primary-7);
}
.Transaction_upper__metrics_totalExpense__SVjuh {
  background-color: var(--color-light-red);
}
.Transaction_upper__metrics_amountOwed__ZEsEC {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Transaction_upper__metrics_totalVat__5oqrh {
  background-color: var(--color-primary-3);
}
.Transaction_upper__searchFilter__Nfgv- {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 5.6rem;
}

.Transaction_searchInMiddle__-vZD3 {
  display: flex;
  width: 100%;
  justify-content: center;
}

.Transaction_invoice__list__dwxM9 {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Transaction_invoice__beside__xn3fW {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}
.Transaction_invoice__checks__KrvmN {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 100%;
}
.Transaction_invoice__checks_group__UJNHA {
  align-self: center;
  width: 100%;
}

.Transaction_table__FyEkQ {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Transaction_table__FyEkQ th,
.Transaction_table__FyEkQ td {
  padding: 2.2rem 0;
}
.Transaction_table__FyEkQ th {
  font-weight: 700;
}
.Transaction_table__FyEkQ tr {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;
  padding: 0 3rem;
}
@media only screen and (max-width: 37.5em) {
  .Transaction_table__FyEkQ tr {
    grid-template-columns: 20% 50% 30%;
  }
}
.Transaction_table__FyEkQ tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Transaction_table__FyEkQ tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Transaction_table__FyEkQ tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Transaction_table__FyEkQ tbody tr > :last-child {
  display: flex;
  justify-content: space-between;
  font-size: var(--default-font-size);
}
@media only screen and (max-width: 37.5em) {
  .Transaction_table__FyEkQ tbody tr > :last-child {
    font-size: var(--default-font-small);
  }
}
.Transaction_table__FyEkQ tbody tr > :last-child > * {
  cursor: pointer;
}
.Transaction_table__FyEkQ tbody tr > :last-child > *:hover {
  color: var(--color-primary);
}
.Transaction_table__FyEkQ tbody tr > :nth-child(5) {
  font-size: 3rem;
  position: relative;
}
.Transaction_table__FyEkQ tbody tr > :nth-child(5) span {
  font-size: 1.2rem;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Transaction_table__FyEkQ tbody tr > :nth-child(5) span:hover {
  opacity: 1;
}

.Transaction_notPaid__ibAHq {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
  position: relative;
  top: 1rem;
}

.Transaction_draft__Ac3sZ {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
  position: relative;
  top: 1rem;
}

.Transaction_partPaid__2dxJr {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-bottom: 1rem;
  width: 83%;
}

.Transaction_expired__C51S6 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-bottom: 1rem;
  width: 83%;
}

.Transaction_paid__5b7qX {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Transaction_ordered__51GJL {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Transaction_minMenu__CJuVE {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 2rem;
}

.Transaction_sideButton__8UZ08 {
  display: flex;
  margin-top: 3rem;
}

.Transaction_summary__to-Va {
  width: 42rem;
  margin-top: 2rem;
}
.Transaction_summary__title__ZJ1te {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Transaction_summary__initials__t9Teb {
  display: flex;
  background-color: var(--color-primary-7);
  font-size: var(--default-font-h3);
  font-weight: 700;
  width: 8rem;
  height: 8rem;
  border-radius: 8rem;
  justify-content: center;
  align-items: center;
}
.Transaction_summary__edit__o8ihL {
  display: flex;
  align-items: flex-end;
  color: var(--color-dark);
  font-size: var(--default-font-small);
  cursor: pointer;
  margin-bottom: 3rem;
}
.Transaction_summary__edit__o8ihL > :last-child {
  font-size: 3rem;
  color: var(--color-primary);
}
.Transaction_summary__edit__o8ihL:hover, .Transaction_summary__edit__o8ihL:focus {
  color: var(--color-primary-4);
  font-weight: 700;
}
.Transaction_summary__line__g5n-u {
  border-top: 1px solid var(--color-dark);
  margin: 2rem 0;
}
.Transaction_summary__dates__xuZpV {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Transaction_summary__dates__xuZpV > :not(:last-child) {
  margin-right: 2rem;
}
.Transaction_summary__total__peEvn {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.Transaction_summary__account__06l5F {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}
.Transaction_summary__button__i6ex7 {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-top: 2rem;
}

.Transaction_error__8bisq {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.Transaction_select__A5BTq {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Transaction_select__A5BTq > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Transaction_select__invoice__gdJs0 {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Transaction_select__invoice_b__OEj5r {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Transaction_select__receipt__D46ZN {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Transaction_select__receipt_b__8rTP2 {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.Transaction_selectCurrency__TKivf {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.Transaction_selectCurrency__text__6DcUE {
  display: flex;
  margin-left: 1rem;
}
.Transaction_selectCurrency__icon__fRWB- {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.Transaction_selectCurrency__icon__fRWB-:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Transaction_selectCurrency__icon_active__yXhjz {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Transaction_selectCurrency__list__NtZGU {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.Transaction_selectCurrency__list_active__Oteq2 {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.Transaction_selectCurrency__list__NtZGU li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.Transaction_selectCurrency__list__NtZGU li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.Transaction_expense__KJBpP {
  font-weight: 700;
  color: var(--color-error);
}

.Transaction_income__UDX4T {
  font-weight: 700;
  color: var(--color-green);
}

.Transaction_filterClass__\\+0VNh {
  display: flex;
  justify-content: space-between;
  margin-top: 8rem;
}
@media only screen and (max-width: 25em) {
  .Transaction_filterClass__\\+0VNh {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Transaction/Transaction.module.scss"],"names":[],"mappings":"AAGC;EACC,aAAA;EACA,cAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;AAFF;AAIE;EACC,eAAA;EACA,eAAA;EACA,oCAAA;AAFH;AAIG;EACC,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AAFJ;AAKG;EAIC,gBAAA;AANJ;;AAYA;EACC,aAAA;EACA,kCAAA;EACA,SAAA;AATD;AAWC;EALD;IAME,gCAAA;EARA;AACF;AAUC;EATD;IAUE,2BAAA;EAPA;AACF;AAUC;EACC,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AARF;AAUE;EATD;IAUE,qCAAA;EAPD;AACF;AASE;EAbD;IAcE,qCAAA;EAND;AACF;AAQE;EAjBD;IAkBE,qCAAA;EALD;AACF;AAOE;EACC,oCAAA;EACA,yBAAA;AALH;AAQE;EACC,qCAAA;AANH;AAUE;EACC,wCAAA;AARH;AAWE;EACC,wCAAA;AATH;AAYE;EACC,oCAAA;EACA,yBAAA;AAVH;AAaE;EACC,wCAAA;AAXH;AAqBC;EACC,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAnBF;;AAuBA;EACC,aAAA;EACA,WAAA;EACA,uBAAA;AApBD;;AAwBC;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;AArBF;AAwBC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAtBF;AAyBC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;AAvBF;AAyBE;EACC,kBAAA;EACA,WAAA;AAvBH;;AAyCA;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAtCD;AAwCC;;EAEC,iBAAA;AAtCF;AAyCC;EACC,gBAAA;AAvCF;AA0CC;EACC,aAAA;EACA,mDAAA;EACA,eAAA;AAxCF;AA0CE;EALD;IAME,kCAAA;EAvCD;AACF;AA2CE;EACC,qBAAA;AAzCH;AA4CE;EACC,wCAAA;EACA,qBAAA;AA1CH;AA4CG;EACC,wCAAA;AA1CJ;AA6CG;EACC,aAAA;EACA,8BAAA;EACA,mCAAA;AA3CJ;AA6CI;EALD;IAME,oCAAA;EA1CH;AACF;AA4CI;EACC,eAAA;AA1CL;AA4CK;EACC,2BAAA;AA1CN;AA+CG;EAWC,eAAA;EACA,kBAAA;AAvDJ;AAyDI;EACC,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AAvDL;AAyDK;EACC,UAAA;AAvDN;;AA+DA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AA5DD;;AA+DA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AA5DD;;AA+DA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AA5DD;;AA+DA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AA5DD;;AA+DA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AA5DD;;AA+DA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AA5DD;;AA+DA;EACC,2BAAA;EACA,eAAA;EACA,eAAA;AA5DD;;AAiEA;EACC,aAAA;EACA,gBAAA;AA9DD;;AAkEA;EACC,YAAA;EACA,gBAAA;AA/DD;AAiEC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AA/DF;AAkEC;EACC,aAAA;EACA,wCAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAhEF;AAmEC;EACC,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;AAjEF;AAmEE;EACC,eAAA;EACA,2BAAA;AAjEH;AAoEE;EAEC,6BAAA;EACA,gBAAA;AAnEH;AAuEC;EACC,uCAAA;EACA,cAAA;AArEF;AAwEC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAtEF;AAwEE;EACC,kBAAA;AAtEH;AA0EC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AAxEF;AA2EC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;AAzEF;AA4EC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AA1EF;;AAgFA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA7ED;;AAgFA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AA9ED;AAgFC;EACC,sBAAA;EACA,kBAAA;AA9EF;AAiFC;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AA/EF;AAiFE;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AA/EH;AAmFC;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAjFF;AAmFE;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAjFH;;AAsFA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAnFD;AAqFC;EACC,aAAA;EACA,iBAAA;AAnFF;AAsFC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AApFF;AAsFE;EACC,4DAAA;EAEA,wCAAA;EACA,2BAAA;AArFH;AAwFE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DAAA;EAEA,wCAAA;EACA,2BAAA;AAvFH;AA4FC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AA3FF;AA+FE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AA7FH;AAiGE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AA/FH;AAiGG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AA/FJ;;AAqGA;EACC,gBAAA;EACA,yBAAA;AAlGD;;AAqGA;EACC,gBAAA;EACA,yBAAA;AAlGD;;AAqGA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;AAlGD;AAoGC;EALD;IAMC,sBAAA;EAjGC;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tmargin: 2rem 0;\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tgap: 2rem;\n\t\twidth: fit-content;\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tborder-bottom: solid 2px var(--color-dark);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.upper {\n\tdisplay: grid;\n\tgrid-template-columns: 72rem 1.5fr;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 60rem 1fr;\n\t}\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 1rem;\n\t\tmargin-bottom: 1rem;\n\t\toverflow: hidden;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(4, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t&_totalIncome {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_outstandingIncome {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t\t// color: var(--color-white);\n\t\t}\n\n\t\t&_totalSales {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\n\t\t&_totalExpense {\n\t\t\tbackground-color: var(--color-light-red);\n\t\t}\n\n\t\t&_amountOwed {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_totalVat {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t// color: var(--color-white);\n\t\t}\n\n\t\t// &_owe {\n\t\t// \tbackground-color: var(--color-error);\n\t\t// \tcolor: var(--color-white);\n\t\t// }\n\t}\n\n\t&__searchFilter {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\tmargin-top: 5.6rem;\n\t}\n}\n\n.searchInMiddle {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n}\n\n.invoice {\n\t&__list {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 38rem;\n\t\tflex-wrap: wrap;\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\t\twidth: 100%;\n\n\t\t&_group {\n\t\t\talign-self: center;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n// .status {\n// \tcontent: none;\n// \twidth: 50%;\n// \tborder-radius: 1rem;\n// \tbackground-color: var(--color-yellow);\n// \tjustify-self: center;\n// \talign-self: center;\n// \tpadding: 3rem;\n// \tdisplay: block;\n// }\n\n//Table styles start\n\n.table {\n\twidth: 100%;\n\tmax-width: 100%;\n\tborder: none;\n\tborder-collapse: collapse;\n\tbox-sizing: border-box;\n\ttext-align: left;\n\tfont-size: var(--default-font-small);\n\n\tth,\n\ttd {\n\t\tpadding: 2.2rem 0;\n\t}\n\n\tth {\n\t\tfont-weight: 700;\n\t}\n\n\ttr {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;\n\t\tpadding: 0 3rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: 20% 50% 30%;\n\t\t}\n\t}\n\n\ttbody {\n\t\t&> :not(:last-child) {\n\t\t\tmargin-bottom: 1.5rem;\n\t\t}\n\n\t\ttr {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tborder-radius: 1.3rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t}\n\n\t\t\t&> :last-child {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tfont-size: var(--default-font-size);\n\n\t\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\t}\n\n\t\t\t\t&>* {\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&> :nth-child(5) {\n\t\t\t\t// content: none;\n\t\t\t\t// width: 3rem;\n\t\t\t\t// height: 3rem;\n\t\t\t\t// border-radius: 0.8rem;\n\n\t\t\t\t// justify-self: center;\n\t\t\t\t// align-self: center;\n\t\t\t\t// padding: 0;\n\t\t\t\t// margin-left: -2rem;\n\n\t\t\t\tfont-size: 3rem;\n\t\t\t\tposition: relative;\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: 1.2rem;\n\t\t\t\t\twidth: fit-content;\n\t\t\t\t\tbackground-color: rgba(0, 0, 0, 0.75);\n\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tpadding: 0.5rem;\n\t\t\t\t\tleft: -1.6rem;\n\t\t\t\t\tborder-radius: 0.5rem;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\topacity: 0;\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.notPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n\tposition: relative;\n\ttop: 1rem;\n}\n\n.draft {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n\tposition: relative;\n\ttop: 1rem;\n}\n\n.partPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n\n.expired {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n\n.paid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n\n.ordered {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n\n.minMenu {\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n\tfont-size: 2rem;\n}\n\n//Table styles end\n\n.sideButton {\n\tdisplay: flex;\n\tmargin-top: 3rem;\n}\n\n//Summary Styles\n.summary {\n\twidth: 42rem;\n\tmargin-top: 2rem;\n\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__initials {\n\t\tdisplay: flex;\n\t\tbackground-color: var(--color-primary-7);\n\t\tfont-size: var(--default-font-h3);\n\t\tfont-weight: 700;\n\t\twidth: 8rem;\n\t\theight: 8rem;\n\t\tborder-radius: 8rem;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t&__edit {\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tcolor: var(--color-dark);\n\t\tfont-size: var(--default-font-small);\n\t\tcursor: pointer;\n\t\tmargin-bottom: 3rem;\n\n\t\t&> :last-child {\n\t\t\tfont-size: 3rem;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: var(--color-primary-4);\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\n\t&__line {\n\t\tborder-top: 1px solid var(--color-dark);\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__dates {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 2rem;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&__total {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__account {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 1rem;\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__button {\n\t\tdisplay: flex;\n\t\tgap: 2rem;\n\t\talign-items: center;\n\t\tmargin-top: 2rem;\n\t}\n}\n\n//Errors\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n}\n\n.select {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t&>* {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__invoice {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__receipt {\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tmargin-left: 1rem;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg)\n\t\t}\n\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.expense {\n\tfont-weight: 700;\n\tcolor: var(--color-error);\n}\n\n.income {\n\tfont-weight: 700;\n\tcolor: var(--color-green);\n}\n\n.filterClass {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 8rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\tflex-direction: column;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_nav": `Transaction_main_nav__xuDbH`,
	"main_nav_item": `Transaction_main_nav_item__Q9ypL`,
	"main_nav_item_active": `Transaction_main_nav_item_active__KDOp8`,
	"upper": `Transaction_upper__sy-C7`,
	"upper__metrics": `Transaction_upper__metrics__0yD9n`,
	"upper__metrics_totalIncome": `Transaction_upper__metrics_totalIncome__73B5G`,
	"upper__metrics_outstandingIncome": `Transaction_upper__metrics_outstandingIncome__i8yyY`,
	"upper__metrics_totalSales": `Transaction_upper__metrics_totalSales__VU09+`,
	"upper__metrics_totalExpense": `Transaction_upper__metrics_totalExpense__SVjuh`,
	"upper__metrics_amountOwed": `Transaction_upper__metrics_amountOwed__ZEsEC`,
	"upper__metrics_totalVat": `Transaction_upper__metrics_totalVat__5oqrh`,
	"upper__searchFilter": `Transaction_upper__searchFilter__Nfgv-`,
	"searchInMiddle": `Transaction_searchInMiddle__-vZD3`,
	"invoice__list": `Transaction_invoice__list__dwxM9`,
	"invoice__beside": `Transaction_invoice__beside__xn3fW`,
	"invoice__checks": `Transaction_invoice__checks__KrvmN`,
	"invoice__checks_group": `Transaction_invoice__checks_group__UJNHA`,
	"table": `Transaction_table__FyEkQ`,
	"notPaid": `Transaction_notPaid__ibAHq`,
	"draft": `Transaction_draft__Ac3sZ`,
	"partPaid": `Transaction_partPaid__2dxJr`,
	"expired": `Transaction_expired__C51S6`,
	"paid": `Transaction_paid__5b7qX`,
	"ordered": `Transaction_ordered__51GJL`,
	"minMenu": `Transaction_minMenu__CJuVE`,
	"sideButton": `Transaction_sideButton__8UZ08`,
	"summary": `Transaction_summary__to-Va`,
	"summary__title": `Transaction_summary__title__ZJ1te`,
	"summary__initials": `Transaction_summary__initials__t9Teb`,
	"summary__edit": `Transaction_summary__edit__o8ihL`,
	"summary__line": `Transaction_summary__line__g5n-u`,
	"summary__dates": `Transaction_summary__dates__xuZpV`,
	"summary__total": `Transaction_summary__total__peEvn`,
	"summary__account": `Transaction_summary__account__06l5F`,
	"summary__button": `Transaction_summary__button__i6ex7`,
	"error": `Transaction_error__8bisq`,
	"select": `Transaction_select__A5BTq`,
	"select__invoice": `Transaction_select__invoice__gdJs0`,
	"select__invoice_b": `Transaction_select__invoice_b__OEj5r`,
	"select__receipt": `Transaction_select__receipt__D46ZN`,
	"select__receipt_b": `Transaction_select__receipt_b__8rTP2`,
	"selectCurrency": `Transaction_selectCurrency__TKivf`,
	"selectCurrency__text": `Transaction_selectCurrency__text__6DcUE`,
	"selectCurrency__icon": `Transaction_selectCurrency__icon__fRWB-`,
	"selectCurrency__icon_active": `Transaction_selectCurrency__icon_active__yXhjz`,
	"selectCurrency__list": `Transaction_selectCurrency__list__NtZGU`,
	"selectCurrency__list_active": `Transaction_selectCurrency__list_active__Oteq2`,
	"expense": `Transaction_expense__KJBpP`,
	"income": `Transaction_income__UDX4T`,
	"filterClass": `Transaction_filterClass__+0VNh`
};
export default ___CSS_LOADER_EXPORT___;
